/** `year` => the same period one year earlier (ComparePeriodType::YEAR), i.e. N-1. */
export const EXPERT_REPORT_COMPARE_WITH = 'year'

export type ExpertReportCompareWith = typeof EXPERT_REPORT_COMPARE_WITH
